// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1y4IC","title":"InfoRow_title__3MAtb"};